import { useState } from 'react'
import axios from 'axios'
import { getApiErrorMessage } from 'utils'

interface AccountChange {
  netsuiteCustomerId: string
  changes: Record<string, { from: any; to: any }>
}

export const useAccountSync = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [syncResult, setSyncResult] = useState<AccountChange[] | null>(null)
  const [updatedCount, setUpdatedCount] = useState(0)

  const syncAccounts = async () => {
    setIsLoading(true)
    setSyncResult(null)
    setUpdatedCount(0)

    try {
      const response = await axios.post('/accounts/sync-accounts')
      const { updatedCount, updates } = response.data
      setUpdatedCount(updatedCount)
      setSyncResult(updates)
    } catch (error) {
      setSyncResult(null)
      throw new Error(getApiErrorMessage(error, 'Failed to sync accounts'))
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    syncResult,
    updatedCount,
    syncAccounts
  }
}
